import { Button, Icon, IconProps } from '@chakra-ui/react';
import { ComponentType } from 'react';
import { FaInstagram } from 'react-icons/fa';
import { createInstagramOnboardingState } from '../utils/onboardingState';

type LogInViaInstagramOnboardingButtonProps = {
  orgId?: string;
};

export const LogInViaInstagramOnboardingButton = ({
  orgId,
}: LogInViaInstagramOnboardingButtonProps) => {
  const handleLogin = () => {
    if (!orgId) {
      return;
    }

    const clientId =
      process.env.REACT_APP_INSTAGRAM_LOGIN_APP_ID || '1120585806916223';
    const redirectUri = encodeURIComponent(
      'https://www.saleradius.com/organization/inbox/instagram/success',
    );
    const scope = encodeURIComponent(
      [
        'instagram_business_basic',
        'instagram_business_manage_messages',
        'instagram_business_manage_comments',
        'instagram_business_content_publish',
        'instagram_business_manage_insights',
      ].join(','),
    );
    const state = encodeURIComponent(createInstagramOnboardingState(orgId));
    const authUrl = `https://www.instagram.com/oauth/authorize?force_reauth=true&client_id=${clientId}&redirect_uri=${redirectUri}&response_type=code&scope=${scope}&state=${state}`;
    window.location.href = authUrl;
  };

  return (
    <Button
      onClick={handleLogin}
      leftIcon={<Icon as={FaInstagram as ComponentType<IconProps>} />}
      size="lg"
      colorScheme="pink"
      borderRadius="full"
      bgGradient="linear(to-r, #f58529, #dd2a7b, #8134af)"
      _hover={{
        bgGradient: 'linear(to-r, #db7c23, #c8246d, #6f2d98)',
        transform: 'translateY(-1px)',
        boxShadow: 'lg',
      }}
      color="white"
      w="full"
      isDisabled={!orgId}
    >
      Connect Instagram account
    </Button>
  );
};
